import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CountrySelectorForm } from '../../util'
import { FormattedMessage } from 'react-intl'
import * as consentActions from 'services/consents/actions'
import {
  selectConsentMatrix,
} from 'services/consents/selectors'
import { Title, SectionTitle, PrivacyWrapper } from '../../util'
import { SubmissionError } from 'redux-form'

const mapStateToProps = (state) => ({
  consentMatrix: selectConsentMatrix(state),
})

const mapDispatchToActions = {
  ...consentActions,
}

export class CountryConfirmation extends Component {

  static propTypes = {
    updateConsents: PropTypes.func,
    consentMatrix: PropTypes.object,
  }

  handleUpdateConsents = ({ country }) => {
    const { consentMatrix, updateConsents } = this.props
    return updateConsents(consentMatrix.version, country)
      .then(() => {
        window.location.href = window.location.href
      })
      .catch((err) => {
        throw new SubmissionError({ _error: err.response.data.error })
      })
  }

  render () {
    return (
      <PrivacyWrapper>
        <Title>
          <FormattedMessage
            id='privacy_center.consents.country.mainheader'
            defaultMessage='Where do you call home?'
          />
        </Title>
        <SectionTitle>
          <FormattedMessage
            id='privacy_center.consents.country.subheader'
            defaultMessage='As part of complying with regional laws, we must first verify your country or region of residency.'
          />
        </SectionTitle>
        <CountrySelectorForm onSubmit={this.handleUpdateConsents} />
      </PrivacyWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(CountryConfirmation)



// WEBPACK FOOTER //
// ./src/components/privacy_center/consents/country/index.jsx